<div>
	<h6 *ngIf="orderReviewReady">File count : ({{files.length}})</h6>
	<button mat-stroked-button class="float-right mt-1 mr-1" (click)="$event.preventDefault();toggleUploadHelp()" (keydown.enter)="$event.preventDefault();">Help</button>
</div>
<div class="modal-body pomodalbody w-100">
	<ng-container *ngIf="!poHelp">
		<div class="row mb-3" *ngIf="!processing_recs && !orderReviewReady">
			<div class="col-md-12 text-center">
				<input type="file" #fileInput style="display: none" (change)="onFileInputChange($event)" multiple accept=".csv,.xlsx,.xls">

				<button mat-raised-button color="primary" (click)="fileInput.click()" class="mb-3">
					<mat-icon>upload_file</mat-icon> Select Files to Upload
				</button>

				<div *ngIf="files.length > 0" class="mt-3">
					<h6>Selected Files ({{files.length}}):</h6>
					<div class="row">
						<div class="col-md-8 offset-md-2">
							<ul class="list-group">
								<li class="list-group-item d-flex justify-content-between align-items-center" *ngFor="let file of files; let i = index">
									<span class="text-truncate" style="max-width: 80%;">{{ file.name }}</span>
									<span class="badge badge-primary badge-pill">{{ (file.size / 1024).toFixed(1) }}
										KB</span>
									<button mat-icon-button color="warn" (click)="onRemove(file)">
										<mat-icon>close</mat-icon>
									</button>
								</li>
							</ul>

							<button mat-stroked-button color="warn" *ngIf="files.length > 0" (click)="clearAllFiles()" class="mt-2">
								<mat-icon>delete_sweep</mat-icon> Clear All
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- Ensure proper event binding for file uploads -->
		<div class="table table-responsive text-center" *ngIf="processing_recs">
			<svg class="spinner" width="65px" height="65px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
				<circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30">
				</circle>
			</svg>
		</div>
		<mat-tab-group *ngIf="orderReviewReady">
			<mat-tab *ngIf="uploadedRawData && uploadedRawData.length > 0">
				<ng-template mat-tab-label>
					<span>Mapping&nbsp;<mat-icon class="text-info align-middle">table_chart</mat-icon></span>
				</ng-template>

				<div class="mt-3">
					<mat-form-field appearance="outline" class="w-25 mb-3">
						<mat-label>Select File View</mat-label>
						<mat-select [(value)]="selectedFile" (selectionChange)="initializeColumnMappings()">
							<mat-option value="all">All Files</mat-option>
							<mat-option *ngFor="let file of availableFiles" [value]="file">
								{{ file }}
							</mat-option>
						</mat-select>
					</mat-form-field>

					<div *ngIf="selectedFile !== 'all'" class="alert alert-info">
						<mat-icon>info</mat-icon> You are viewing mappings for <strong>{{ selectedFile }}</strong>.
						These mappings will only apply to data from this file.
					</div>

					<div *ngIf="selectedFile === 'all'" class="alert alert-info">
						<mat-icon>info</mat-icon> You are viewing all files together. Changes here will apply to all
						files that have the same column names.
					</div>
					<div class="table-responsive">
						<table class="table table-striped table-sm">
							<thead>
								<tr class="border-danger">
									<ng-container *ngIf="selectedFile === 'all'">
										<th *ngFor="let header of uploadedHeaders" class="small text-muted">
											{{ header }}
										</th>
									</ng-container>
									<ng-container *ngIf="selectedFile !== 'all'">
										<th *ngFor="let header of fileSpecificHeaders[selectedFile]" class="small text-muted">
											{{ header }}
										</th>
									</ng-container>
								</tr>
								<tr>
									<ng-container *ngIf="selectedFile === 'all'">
										<th *ngFor="let header of uploadedHeaders" style="min-width: 120px;" [ngClass]="{'border-danger': dupedSuppliedHeaders[header]}">
											<mat-form-field appearance="outline" class="w-100" style="margin-bottom: -1.25em;">
												<mat-select [(value)]="columnMappings[header]" (selectionChange)="updateColumnMapping(header, $event.value)">
													<mat-option *ngFor="let type of availableFieldTypes" [value]="type">
														<span [ngClass]="suppliedHeaders[type] ? 'text-danger' : ''">{{ type }}</span>
													</mat-option>
												</mat-select>
											</mat-form-field>
										</th>
									</ng-container>

									<ng-container *ngIf="selectedFile !== 'all'">
										<th *ngFor="let header of fileSpecificHeaders[selectedFile]" style="min-width: 120px;">
											<mat-form-field appearance="outline" class="w-100" style="margin-bottom: -1.25em;">
												<mat-select [(value)]="fileSpecificMappings[selectedFile][header]" (selectionChange)="updateColumnMapping(header, $event.value, selectedFile)">
													<mat-option *ngFor="let type of availableFieldTypes" [value]="type">
														<span [ngClass]="suppliedHeaders[type] ? 'text-danger' : ''">{{ type }}</span>
													</mat-option>
												</mat-select>
											</mat-form-field>
										</th>
									</ng-container>
								</tr>
							</thead>
							<tbody>
								<ng-container *ngIf="selectedFile === 'all'">
									<tr *ngFor="let row of uploadedRawData">
										<td *ngFor="let header of uploadedHeaders">{{ row[header] }}</td>
									</tr>
								</ng-container>

								<ng-container *ngIf="selectedFile !== 'all'">
									<tr *ngFor="let row of uploadedRawData" [hidden]="row._sourceFile !== selectedFile">
										<td *ngFor="let header of fileSpecificHeaders[selectedFile]">{{
											row[header]}}</td>
									</tr>
								</ng-container>
							</tbody>
						</table>
					</div>

					<div class="d-flex justify-content-end">
						<!-- <button mat-raised-button color="primary" class="mt-3 mr-3"
								[disabled]="hasDuplicateMappings" (click)="applyMappingsAndProcessOrder()">
								<mat-icon>check</mat-icon> Apply Mappings
							</button> -->
					</div>
				</div>
			</mat-tab>
			<mat-tab *ngIf="orderDataSource && orderDataSource['good']">
				<ng-template mat-tab-label>
					<span>Recognized&nbsp;({{orderDataSource['good'].data.length}})&nbsp;<mat-icon class="text-success align-middle">done</mat-icon></span>
				</ng-template>
				<table class="table table-striped table-sm mt-3">
					<thead>
						<tr>
							<th>Stock ID</th>
							<th>Description</th>
							<th>Quantity</th>
							<th>Price</th>
						</tr>
					</thead>
					<tbody>
						<tr *ngFor="let element of orderDataSource['good'].data">
							<td>{{ element.stockid }}</td>
							<td>{{ element.description }}</td>
							<td class="text-center">{{ element.quantity }}</td>
							<td>{{ element.price | currency }}</td>
						</tr>
					</tbody>
				</table>
			</mat-tab>
			<mat-tab *ngIf="orderDataSource && orderDataSource['bad']">
				<ng-template mat-tab-label>
					<span>Unrecognized&nbsp;({{orderDataSource['bad'].data.length}})&nbsp;<mat-icon class="text-danger align-middle">announcement</mat-icon></span>
				</ng-template>
				<table class="table table-striped table-sm mt-3">
					<thead>
						<tr>
							<th>Stock ID</th>
							<th>Description</th>
							<th>Quantity</th>
							<th>Price</th>
						</tr>
					</thead>
					<tbody>
						<tr *ngFor="let element of orderDataSource['bad'].data">
							<td>{{ element.stockid }}</td>
							<td>{{ element.description }}</td>
							<td class="text-center">{{ element.quantity }}</td>
							<td>{{ element.price | currency }}</td>
						</tr>
					</tbody>
				</table>
			</mat-tab>
		</mat-tab-group>
	</ng-container>
	<ng-container *ngIf="poHelp">
		<div class="row">
			<div class="col">
				<h4><b>Headers</b></h4>
				<h6 class="warning">(These are required to be exact matches, order of columns isn't important)</h6>
				<ol>
					<li>stockid</li>
					<li>qty_purchase</li>
					<li>price</li>
				</ol>
				<hr>
				<h4><b>Notes</b></h4>
				<ul style="max-height: 150px;" class="overflow-auto">
					<li>
						<p>Each stockid is validated within the system. If a match is found it will be shown under
							the recognized tab, otherwise it will be under the unrecognized tab.</p>
					</li>
					<li>
						<p>Only recognized items will be added to your order.</p>
					</li>
					<li>
						<p>Multiple files can be uploaded at once and will be merged into a single order.</p>
					</li>
					<li>
						<p>When price is left blank, the system will use the default price for the customer.</p>
					</li>
					<li>
						<p>Lines with a qty_purchase of 0 are ignored.</p>
					</li>
					<li>
						<p>Files can be removed during the upload step by hovering over the title of the file and
							clicking the <mat-icon>cancel</mat-icon> button.</p>
					</li>
				</ul>
			</div>
			<mat-divider vertical="true"></mat-divider>
			<div class="col">
				<h4><b>Row Data</b></h4>
				<h6>(Stock IDs are validated within the system)</h6>
				<ol>
					<li>
						Stock ID you are ordering as it appears in the system.
						<ul>
							<li>ITEM-12345 <mat-icon>done</mat-icon></li>
							<li>"ITEM-12345" <span style="color: red;">(quotes)</span></li>
						</ul>
					</li>
					<li>
						Quantity to Order.
						<ul>
							<li>4 <mat-icon>done</mat-icon></li>
							<li>four <span style="color: red;">(non-numeric value)</span></li>
						</ul>
					</li>
					<li>
						Price of a single item with no commas.
						<ul>
							<li>78.92<mat-icon>done</mat-icon></li>
							<li>1,274.22 <span style="color: red;">(comma)</span></li>
						</ul>
					</li>
				</ol>
				<hr>
				<h4>Supported File Formats</h4>
				<ul>
					<li>Excel (.xlsx, .xls)</li>
					<li>CSV (.csv)</li>
				</ul>
			</div>
		</div>
	</ng-container>
</div>
<div class="modal-footer">

	<button mat-stroked-button *ngIf="!orderReviewReady" class="pomodalbtn" (click)="$event.preventDefault();uploadOrder()" (keydown.enter)="$event.preventDefault();" [disabled]="files.length == 0">Process File(s)</button>
	<ng-container *ngIf="!mappingsFulfilled.status">
		<div class="abs-left"><small>Required Maps: </small><small class="text-danger" *ngFor="let type of requiredMappings | keyvalue">
			<ng-container *ngIf="!type.value"> {{type['key']}}&nbsp;</ng-container>
		</small></div>
	</ng-container>
	<button mat-stroked-button *ngIf="orderReviewReady" class="pomodalbtn float-left" (click)="$event.preventDefault();resetUploadOrder()" (keydown.enter)="$event.preventDefault();">Back</button>
	<div class="ml-2 mr-2" *ngIf="orderReviewReady && config.env.package === 'tires'">PLL<mat-slide-toggle [value]="lookupType" (toggleChange)="changeLookup()"></mat-slide-toggle>MFG</div>
	<button *ngIf="orderReviewReady" mat-raised-button [ngClass]="orderDataSource ? 'btn-warn' : 'btn-blue'" class="" [disabled]="!checkForRequiredFields() || hasDuplicateMappings" (click)="applyMappingsAndProcessOrder()">
		<mat-icon>check</mat-icon>
		<ng-container *ngIf="orderDataSource">Re-</ng-container>
		Apply Mappings
	</button>
	<button mat-stroked-button *ngIf="orderReviewReady && orderDataSource && orderDataSource['good']" class="pomodalbtn" (click)="$event.preventDefault();addOrderItems()" (keydown.enter)="$event.preventDefault();" [disabled]="hasDuplicateMappings">
		Add To Order
	</button>
</div>
